import { render, staticRenderFns } from "./DraftPreviewActivity.vue?vue&type=template&id=9ccd425a&scoped=true"
import script from "./DraftPreviewActivity.vue?vue&type=script&lang=js"
export * from "./DraftPreviewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccd425a",
  null
  
)

export default component.exports